import { returnZero } from '@ardoq/common-helpers';
import { fontFamily } from '@ardoq/design-tokens';
import { truncateComponentLabel, type ComponentLabelParts } from '@ardoq/graph';
import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { IconSize } from '@ardoq/icons';
import {
  COMPONENT_TREE_ICON_RIGHT_MARGIN,
  COMPONENT_TREE_ROW_HORIZONTAL_PADDING,
  COMPONENT_TREE_ROW_MAX_WIDTH,
} from '../consts';

const LABEL_MAX_WIDTH =
  COMPONENT_TREE_ROW_MAX_WIDTH -
  COMPONENT_TREE_ROW_HORIZONTAL_PADDING -
  IconSize.MEDIUM -
  COMPONENT_TREE_ICON_RIGHT_MARGIN -
  IconSize.SMALL -
  COMPONENT_TREE_ICON_RIGHT_MARGIN;

const COMPONENT_TREE_LABEL_FONT = `400 14px/20px ${fontFamily.regular}`;
const measureLabel = canvasLabelMeasurer(COMPONENT_TREE_LABEL_FONT);

type ComponentTreeLabels = {
  displayLabel: string;
  fullLabel: string;
};

/** A row's label truncated to fit the row, and in full for the popover. */
export const toComponentTreeLabels = (
  componentLabelParts: ComponentLabelParts
): ComponentTreeLabels => ({
  displayLabel: truncateComponentLabel({
    ...componentLabelParts,
    measure: measureLabel,
    width: LABEL_MAX_WIDTH,
  }),
  fullLabel: truncateComponentLabel({
    ...componentLabelParts,
    measure: returnZero,
    width: Infinity,
  }),
});
